import React, {useState} from 'react';
import {Link} from "react-router-dom";
import Swal from "sweetalert2";
import {getImpresionCotizacionPDF} from "../../../services/cotizador-service";
import loading from "@images/pulse-loader.svg";
import ModalCoverages from "../../Modals/Modal-Coverages";
import Tooltip from "react-bootstrap/Tooltip";
import {OverlayTrigger} from "react-bootstrap";

export default function InsuranceCard(props) {

    const isAuthenticated = localStorage.getItem("isAuthenticated");


    //Coverages list
    const [showModalCoverages, setShowModalCoverages] = useState(false);
    const toggleModalCoverages = () => {
        setShowModalCoverages(!showModalCoverages);
    };
    console.log(props.userPermissions)
    return (
        <>

            {showModalCoverages ?
                <ModalCoverages isOpen={showModalCoverages} toggle={toggleModalCoverages}
                                coverages={props.coverages}/> : null}

            <div className="row justify-content-center mt-2">
                <div className={props.cardSize}>
                    <div className={`card text-center py-2 ${props.cardBorder}`}>

                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                <img className={`card-img-top ${props.imageStyles}`} src={props.cardImg}
                                     alt={props.companyName}/>
                            </div>

                            {props.loadingAnimation ?
                                <img className="col-sm-12 col-md-6 col-lg-8" src={loading}
                                     alt="img-insurance" style={{height: '14vh'}}/> :

                                <div className="card-body input-top col-sm-12 col-md-6 col-lg-9">

                                    {props.showError ?
                                        <p className="text-danger text-center mt-3 mx-5 small">
                                            <strong>No se puede cotizar con {props.companyName.toUpperCase()}:
                                            </strong>{' ' + props.showErrorMessage}
                                        </p> : null}

                                    {props.showPrice ? null :
                                        <div className="col-12">
                                            <div className="input-group mt-2" hidden={props.showError}>

                                                <select name={props.companyFormik}
                                                        onChange={props.handleChange}
                                                        className="form-control form-select mx-5"
                                                        id={`rank_${props.companyName}`}
                                                        disabled={!props.vehicles.length}>

                                                    {props.vehicles.length ? null :
                                                        <option selected disabled
                                                                onChange={props.handleChange}>Seleccionar...
                                                        </option>}

                                                    {props.vehicles.map(option => (
                                                        <option key={option.modelString}
                                                                value={option.modelString}
                                                                onChange={props.handleChange}>
                                                            {option.modelString}
                                                        </option>))}

                                                </select>
                                            </div>
                                        </div>}

                                    {props.showPrice ?
                                        <div>
                                            <div className="row align-items-center text-center justify-content-center my-auto mx-auto">
                                                {props.receiptInfo.totalPremium ?
                                                <div className="col-sm-12 col-md-12 col-lg-auto border-end small">
                                                    <h6><b>Costo Total:</b></h6>
                                                    <h6>${props.receiptInfo.totalPremium?.toLocaleString('en', {maximumFractionDigits: 2})}</h6>
                                                </div>: null}
                                                {props.receiptInfo.quantity != 1 ?
                                                <div className="col-sm-12 col-md-6 col-lg-auto border-end small">
                                                    <h6>Primer Pago:</h6>
                                                    <h6>${props.receiptInfo.firstReceiptAmount?.toLocaleString('en', {maximumFractionDigits: 2})}</h6>
                                                </div> : null }
                                                {props.receiptInfo.subsequentReceiptsAmount ?
                                                    <div className="col-sm-12 col-md-6 col-lg-auto border-end small">
                                                    <h6>{props.receiptInfo.quantity - 1} pagos de:</h6>
                                                    <h6>${props.receiptInfo.subsequentReceiptsAmount?.toLocaleString('en', {maximumFractionDigits: 2})}</h6>
                                                </div> : null}

                                                <div className="col-auto small">
                                                    {isAuthenticated ?
                                                        <Link
                                                            to={`/emision=private/${props.companyID}/${props.movementId}/${props.formikValues.cp}/${props.formikValues.payment}`}>
                                                            <button hidden={props.userPermissions[2] !== 1}
                                                                className="btn btn-skr-secondary btn-sm mt-2 m-1 py-2 small">
                                                                Adquiere tu seguro
                                                            </button>
                                                        </Link> :
                                                        <Link
                                                            to={`/emision=public/${props.companyID}/${props.movementId}/${props.formikValues.cp}/${props.formikValues.payment}`}>
                                                            <button
                                                                className="btn btn-skr-secondary btn-sm mt-2 m-1 py-2 small">
                                                                Adquiere tu seguro
                                                            </button>
                                                        </Link>}

                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Descargar PDF</Tooltip>}>
                                                    <button type="button" onClick={() => {
                                                        Swal.fire({
                                                            title: 'Descargando PDF...',
                                                            showConfirmButton: false,
                                                            allowOutsideClick: false,
                                                            didOpen: () => {
                                                                Swal.showLoading()
                                                                return getImpresionCotizacionPDF(props.movementId).then(data => {
                                                                    const url = window.URL.createObjectURL(new Blob([data]));
                                                                    const link = document.createElement('a');
                                                                    link.href = url;
                                                                    link.setAttribute('download', props.quoteNumber + '.pdf');
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                }).then(() => Swal.close()).catch(() => {
                                                                    Swal.fire({
                                                                        title: 'Ocurrió un error',
                                                                        text: `No se pudo descargar el PDF`,
                                                                        icon: 'error',
                                                                        iconColor: 'var(--skrSecondary)',
                                                                        backdrop: `rgba(71, 10, 104, .75)`,
                                                                        showCancelButton: true,
                                                                        showConfirmButton: false,
                                                                        cancelButtonColor: '#D0006FFF',
                                                                        cancelButtonText: 'Ok'
                                                                    });
                                                                })
                                                            }
                                                        })
                                                    }} className="btn btn-skr-secondary mt-1"
                                                             hidden={props.userPermissions[1] !== 1}><i
                                                        className="bi-file-arrow-down"></i>
                                                    </button>
                                                    </OverlayTrigger>
                                                    <br/>
                                                    <button type="button"
                                                            className="btn btn-link small"
                                                            disabled={props.disabled} onClick={toggleModalCoverages}>
                                                        Detalle de la cobertura
                                                    </button>
                                                </div>
                                            </div>
                                        </div> : null}
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}